import React, { useState, useEffect } from "react";
import firebase from 'firebase/compat/app';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import axios from "axios";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import "../CSS/CourseEdit.css";

const CourseEdit = () => {
    const [titleName, setTitleName] = useState("");
    const [titleDescription, setTitleDescription] = useState("");
    const [route, setRoute] = useState("");
    const [image, setImage] = useState(null);
    const [pdf, setPdf] = useState(null);
    const [subtitles, setSubtitles] = useState([]);
    const [imageUrl, setImageUrl] = useState("");
    const [pdfUrl, setPdfUrl] = useState("");
    const [editServiceId, setEditServiceId] = useState(null);

    const [serviceData, setServiceData] = useState([]);
    const [message, setMessage] = useState("");
    const [expandedSubtitles, setExpandedSubtitles] = useState({});

    const [subtitles2, setSubtitles2] = useState([]);
    const [subtitles3, setSubtitles3] = useState([]);

    useEffect(() => {
        fetchServiceData();
    }, []);

    const addSubtitle = () => {
        const newSubtitleId = subtitles.length + 1; 
        setSubtitles([...subtitles, { subtitle_id: newSubtitleId, subdescription: "" }]);
    };

    const addSubtitle2 = () => {
        const newSubtitleId = subtitles2.length + 1; 
        setSubtitles2([...subtitles2, { subtitle_id: newSubtitleId, subdescription: ""}]);
    };

    const addSubtitle3 = () => {
        const newSubtitleId = subtitles3.length + 1; 
        setSubtitles3([...subtitles3, { subtitle_id: newSubtitleId, subdescription: "" }]);
    };


    const removeSubtitle = (index) => {
        setSubtitles(subtitles.filter((_, i) => i !== index));
    };

    const removeSubtitle2 = (index) => {
        setSubtitles2(subtitles2.filter((_, i) => i !== index));
    };

    const removeSubtitle3 = (index) => {
        setSubtitles3(subtitles3.filter((_, i) => i !== index));
    };

    const handleSubtitleChange = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`Works/subtitles/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles(newSubtitles);
    };


    const handleSubtitleChange2 = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles2];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle2_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`Works/subtitles2/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles2(newSubtitles);
    };

    const handleSubtitleChange3 = async (index, field, value, file = null) => {
        const newSubtitles = [...subtitles3];
        if (field === "subimage" && file) {
            try {
                const imageName = `${titleName.replace(/\s+/g, '_')}_subtitle3_${index + 1}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`Works/subtitles3/${imageName}`);
                await imageRef.put(file);
                const uploadedImageUrl = await imageRef.getDownloadURL();
                newSubtitles[index][field] = uploadedImageUrl;
            } catch (error) {
                console.error("Error uploading subimage:", error);
            }
        } else {
            newSubtitles[index][field] = value;
        }
        setSubtitles3(newSubtitles);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
    
        try {
            let uploadedImageUrl = imageUrl;
            if (image) {
                const imageName = `${titleName.replace(/\s+/g, '_')}.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`Courses/${imageName}`);
                await imageRef.put(image);
                uploadedImageUrl = await imageRef.getDownloadURL();
            }

            let uploadPdfUrl = pdfUrl;
            if (pdf) {
                const imageName =  `${titleName.replace(/\s+/g, '_')}pdf.jpg`;
                const storageRef = firebase.storage().ref();
                const imageRef = storageRef.child(`Courses/pdf/${imageName}`);
                await imageRef.put(pdf);
                uploadPdfUrl = await imageRef.getDownloadURL();
            }

    
            const subtitleData = await Promise.all(
                subtitles.map(async (sub, index) => {
                    return {
                        subtitle_id: sub.subtitle_id,
                        subdescription: sub.subdescription || "",
                    };
                })
            );


            const subtitleData2 = await Promise.all(
                subtitles2.map(async (sub, index) => {
                    return {
                        subtitle_id: sub.subtitle_id,
                        subdescription: sub.subdescription || "",
                    };
                })
            );

            const subtitleData3 = await Promise.all(
                subtitles3.map(async (sub, index) => {
                    return {
                        subtitle_id: sub.subtitle_id,
                        subdescription: sub.subdescription || "",
                    };
                })
            );




            const formData = {
                title: titleName,
                description: titleDescription,
                route,
                imageUrl: uploadedImageUrl,
                pdfUrl: uploadPdfUrl,
                subtitles: subtitleData,
                subtitles2: subtitleData2,
                subtitles3: subtitleData3,
                service_id: editServiceId || null
            };
    
            if (editServiceId) {
                await axios.put(`https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/updateCourse/${editServiceId}`, formData);
                setMessage("Service updated successfully!");
            } else {
                await axios.post("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/addCourse", formData);
                setMessage("Service added successfully!");
            }
    
            fetchServiceData();
            resetForm();
        } catch (error) {
            console.error("Error submitting service data:", error);
            setMessage("Failed to submit service. Please try again.");
        }
    };

    const resetForm = () => {
        setTitleName("");
        setTitleDescription("");
        setRoute("");
        setImage(null);
        setPdf(null);
        setImageUrl("");
        setPdfUrl("");
        setSubtitles([]);
        setSubtitles2([]);
        setSubtitles3([]);
        setEditServiceId(null);
    };

    const fetchServiceData = async () => {
        try {
            const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getCourse");
            setServiceData(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error("Error fetching service data:", error);
        }
    };

    const handleEdit = (item) => {
        setTitleName(item.title);
        setTitleDescription(item.description);
        setRoute(item.route);
        setImageUrl(item.imageUrl);
        setPdfUrl(item.pdfUrl);
        setSubtitles(item.subtitles || []);
        setSubtitles2(item.subtitles2 || []);
        setSubtitles3(item.subtitles3 || []);
        setEditServiceId(item.service_id);
    };

    const handleDelete = async (serviceId) => {
        try {
            await axios.delete(`https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/deleteCourse/${serviceId}`);
            setMessage("Service entry deleted successfully!");
            fetchServiceData();
        } catch (error) {
            console.error("Error deleting service entry:", error);
            setMessage("Failed to delete service entry. Please try again.");
        }
    };

    const toggleSubtitles = (serviceId) => {
        setExpandedSubtitles(prev => ({
            ...prev,
            [serviceId]: !prev[serviceId]
        }));
    };

    return (
        <div className="courseEdit-section">
            <div className="container">
                <h2 className="text-center mb-4">Edit Course Section</h2>
                <form onSubmit={handleSubmit}>
                    <h5 className="text-center">First Section & Title</h5>
                            <input type="text" value={titleName} className="col-md-4" onChange={(e) => setTitleName(e.target.value)} placeholder="Title Name" />
                            <input type="text" value={titleDescription} className="col-md-4" onChange={(e) => setTitleDescription(e.target.value)} placeholder="Description" />
                            <input type="text" value={route} className="col-md-4" onChange={(e) => setRoute(e.target.value)} placeholder="Route" />
                            {imageUrl && <div><img src={imageUrl} alt="service" style={{ width: "100px", height: "100px" }} /></div>}
                            <input type="file" onChange={(e) => setImage(e.target.files[0])} />
                            <h5>Upload Pdf Course</h5>
                            {pdfUrl && <div><img src={pdfUrl} alt="course" style={{ width: "100px", height: "100px" }} /></div>}
                            <input type="file" onChange={(e) => setPdf(e.target.files[0])} />
                            <h5 className="text-center">Who is the Training for?</h5>
                            {subtitles2.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange2(index, "subdescription", e.target.value)} placeholder="Subpoints" />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle2(index)}>Remove</button>
                                </div>
                            ))}
                            <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle2}>Add Subtitle</button>





                    <h5 className="text-center">What Is Covered in the Training?</h5>
                            {subtitles.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange(index, "subdescription", e.target.value)} placeholder="Subdescription" />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle(index)}>Remove</button>
                                </div>
                            ))}
                        <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle}>Add Subtitle</button>



                    <h5 className="text-center">KeyTopics</h5>
                            {subtitles3.map((sub, index) => (
                                <div className="p-4" key={index}>
                                    <input type="text" value={sub.subdescription} className="col-md-4" onChange={(e) => handleSubtitleChange3(index, "subdescription", e.target.value)} placeholder="Subdescription" />
                                    <button type="button" className="btn btn-danger mt-3" onClick={() => removeSubtitle3(index)}>Remove</button>
                                </div>
                            ))}
                            <button className="btn btn-secondary mt-3 mb-4" type="button" onClick={addSubtitle3}>Add Subtitle</button>    




                   

                    <button className="btn btn-primary mt-3" type="submit">Save Changes</button>
                    {message && <p>{message}</p>}
                </form>

                <h2>Service Entries</h2>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Route</th>
                            <th>Image</th>
                            <th>Subtitles</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceData.map((item) => (
                            <tr key={item.service_id}>
                                <td>{item.title}</td>
                                <td>{item.description}</td>
                                <td>{item.route}</td>
                                <td><img src={item.imageUrl} alt="service" style={{ width: "50px", height: "50px" }} /></td>
                                <td>
                                    <button onClick={() => toggleSubtitles(item.service_id)}>
                                        {expandedSubtitles[item.service_id] ? <FaArrowUp /> : <FaArrowDown />}
                                    </button>
                                </td>
                                <td><button onClick={() => handleEdit(item)}>Edit</button></td>
                                <td><button onClick={() => handleDelete(item.service_id)}>Delete</button></td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {serviceData.map((item) => (
                    expandedSubtitles[item.service_id] && (
                        <div key={`subtitle-table-${item.service_id}`}>
                            <h4>Subtitles for {item.title}:</h4>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                    
                                        <th>Subdescription1</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.subtitles.map((sub, index) => (
                                        <tr key={index}>
                                           
                                            <td>{sub.subdescription}</td>
                                
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                    
                                        <th>Subdescription2</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.subtitles2.map((sub, index) => (
                                        <tr key={index}>
                                           
                                            <td>{sub.subdescription}</td>
                                
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                    
                                        <th>Subdescription3</th>
                                       
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.subtitles3.map((sub, index) => (
                                        <tr key={index}>
                                           
                                            <td>{sub.subdescription}</td>
                                
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default CourseEdit;
